import React from "react";

const PrimaryTrackInlineLogo = () => {
  return (
    <div style={{ marginRight: "10px", display: "inline-block" }}>
      <span className="primary-track-logo" style={{ padding: "0" }}>
        P
      </span>
    </div>
  );
};

export default PrimaryTrackInlineLogo;



// WEBPACK FOOTER //
// ./src/libraries/ReportGenerator/PrimaryTrackInlineLogo.jsx